// extracted by mini-css-extract-plugin
export var checkboxInputRow = "r_q3";
export var checkboxInputColumn = "r_q4";
export var inputOptionRow = "r_pz";
export var inputOptionColumn = "r_pB";